import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "bookmark--sprite",
  "use": "bookmark--sprite-usage",
  "viewBox": "0 0 17 17",
  "content": "<symbol viewBox=\"0 0 17 17\" xmlns=\"http://www.w3.org/2000/svg\" id=\"bookmark--sprite\">\n<path d=\"M11.9095 14.6231L7.24284 12.6231L2.57617 14.6231V3.95646C2.57617 3.22313 3.17617 2.62313 3.90951 2.62313H8.57617C8.15617 3.18313 7.9095 3.8698 7.9095 4.62313C7.9095 6.46313 9.40284 7.95646 11.2428 7.95646C11.4695 7.95646 11.6962 7.93646 11.9095 7.8898V14.6231ZM11.1295 6.62313L9.24284 4.73646L10.1828 3.79646L11.1228 4.73646L13.4828 2.37646L14.4228 3.31646L11.1295 6.62313Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol